import { useEffect, useRef } from 'react';

const useScrollToView = (shouldScrollToView: boolean) => {
	const scrollToViewRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (!shouldScrollToView) {
			return;
		}

		scrollToViewRef.current.scrollIntoView({
			behavior: 'smooth',
			block: 'start'
		});
	}, [shouldScrollToView]);

	return scrollToViewRef;
};

export default useScrollToView;
